const ARRAY_FIELDS = [
  'works_with',
  'typical_settings',
  'key_responsibilities',
  'not_qualified_to',
  'locations',
];

const OBJECT_ARRAY_FIELDS = ['faqs'];

export function parsePossiblySerialized(value, fallback = value) {
  if (value == null) return value;
  if (Array.isArray(value) || typeof value === 'object') return value;
  if (typeof value !== 'string') return fallback;

  const trimmed = value.trim();
  if (!trimmed) return fallback;

  const looksSerialized =
    (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
    (trimmed.startsWith('{') && trimmed.endsWith('}'));

  if (!looksSerialized) return fallback;

  try {
    return JSON.parse(trimmed);
  } catch {
    return fallback;
  }
}

export function ensureArray(value) {
  if (Array.isArray(value)) return value;
  const parsed = parsePossiblySerialized(value, value);
  if (Array.isArray(parsed)) return parsed;
  if (typeof value === 'string' && value.trim()) return [value.trim()];
  return [];
}

export function normalizeRoleData(role) {
  if (!role || typeof role !== 'object') return role;

  const normalized = { ...role };

  for (const field of [...ARRAY_FIELDS, ...OBJECT_ARRAY_FIELDS]) {
    normalized[field] = ensureArray(normalized[field]);
  }

  for (const [key, value] of Object.entries(normalized)) {
    if (/_fr$|_ar$|_bn$|_pa$|_pl$|_ro$|_so$|_ur$|_es$/.test(key)) {
      const baseField = key.replace(/_(fr|ar|bn|pa|pl|ro|so|ur|es)$/, '');
      if (ARRAY_FIELDS.includes(baseField) || OBJECT_ARRAY_FIELDS.includes(baseField)) {
        normalized[key] = ensureArray(value);
      }
    }
  }

  return normalized;
}
